$(document).on("swell:initialized", function () {
    swellAPI.getActiveCampaigns().forEach(function (e) {
        var i = e.title,
            o = "Refer",
            t = "review";
        if (-1 != i.indexOf("Refer")) var a = '<a class="eob-earn btn_primary" id="ref-popup-trigger" data-campaign-id="' + e.id + '">' + e.ctaText + "</a>";
        else if (-1 != i.indexOf("review")) var a = "";
        else var a = '<a class="swell-campaign-link eob-earn btn_primary" data-campaign-id="' + e.id + '"data-display-mode="modal" href="javascript:void(0)">' + e.ctaText + "</a>";
        $("#earn-points").append(
            "<li data-campaign-id=" + e.id + '><div class="content"><i class="progress icon fa ' + e.icon + '"></i><i class="complete icon fa fa-check"></i><h3>' + e.title + "</h3><p>" + e.details + "</p>" + a + "</div></li>"
        ),
            $(".loader.earn").hide();
    });
}),
    $(document).on("swell:setup", function () {
        function e(e) {
            var i = document.createRange();
            i.selectNode(document.getElementById(e)), window.getSelection().removeAllRanges(), window.getSelection().addRange(i), document.execCommand("copy"), window.getSelection().removeAllRanges(), $("#link-copied").show();
        }
        var i = swellAPI.getCustomerDetails(),
            o = i.pointsBalance;
        $("#custom-point-balance-ui").html(o), $("#custom-referral-link-ui").html(i.referralLink);
        var t = parseInt(o);
        $("#redemption-option-select").attr("data-customer", t);
        var a = $("#redeemed-history-holder").data("redeemed");
        i.pointRedemptions.forEach(function (e) {
            if (1 == e.visible) {
                if (a.includes(e.reward_text)) var i = "redeemed";
                else var i = "active";
                "active" == i &&
                    ($("#redeemed-history").append('<li><h3 class="offer ' + i + '">' + e.redemption_option.name + '</h3><h3 class="code">' + e.reward_text + "</h3></li>"),
                    $("#redeemed-history-holder").addClass("got-rewards"),
                    $(".rewards-list").addClass("got-rewards"));
            }
        }),
            swellAPI.getActiveCampaigns().forEach(function (e) {
                if (1 == e.customerCompleted) var i = "status-done";
                else var i = "status-active";
                $("#earn-points")
                    .find("li[data-campaign-id='" + e.id + "']")
                    .addClass(i),
                    $("#earn-points")
                        .find("li[data-campaign-id='" + e.id + "']")
                        .find("a.eob-earn")
                        .addClass(i);
            }),
            $(".rewards_trigger").on("click", function () {
                swellAPI.showPopupByType("RewardsPopup");
            }),
            $("#ref-popup-trigger").click(function (e) {
                $("#ref-popup").addClass("show").removeClass("hide"), $(".popup_overlay").addClass("show").removeClass("hide");
            }),
            $("#ref-popup-close").click(function (e) {
                $("#ref-popup").addClass("hide").removeClass("show"), $(".popup_overlay").addClass("hide").removeClass("show");
            });
        var s = $("#referred-customers-input"),
            n = $("#referred-customers-send-btn");
        $(n).click(function () {
            var e;
            if (s.val().includes(",")) $("#error-multiple").show();
            else {
                var i = s.val().split(","),
                    o = function () {
                        $("#error").hide(), $("#error-multiple").hide(), $("#success").show(), $("#referredCustomersInput").val("");
                    },
                    t = function (e) {
                        $("#error").show(), $("#success").hide();
                    };
                swellAPI.sendReferralEmails(i, o, t);
            }
        }),
            swellAPI.getActiveRedemptionOptions().forEach((e) => {
                $("#redeem-points").append('<li><h3 class="title">' + e.name + '</h3><h3 class="points">With ' + e.costInPoints + " EOB Points</h3></li>"), $(".loader.redeem").hide();
            });
        var r = parseInt($("#redemption-option-select").attr("data-customer"));
        swellAPI.getActiveRedemptionOptions().forEach((e) => {
            var i = parseInt(e.costInPoints);
            r >= i &&
                ($("#redemption-option-select").append(
                    '<div class="redemption-option-holder" data-points="' +
                        e.costInPoints +
                        '"><input type="radio" name="redeem" id="' +
                        e.id +
                        '" value="' +
                        e.id +
                        '" /><label style="display:block" class="redemption-option" value="' +
                        e.id +
                        '" for="' +
                        e.id +
                        '">' +
                        e.name +
                        "</label></div>"
                ),
                $(".action-redeem").show(),
                $("#coupon-code-submit-btn").show());
        }),
            $("#redemption-option-select").find("input[type='radio']").first().prop("checked", !0);
        var d = function (e) {
            var i;
            $("#redemption-option-select input:checked").val(e);
        };
        $("#coupon-code-submit-btn").click(function () {
            var e = $("#redemption-option-select input:checked"),
                i = function (e) {
                    d(e.couponCode), $("#redeemsuccess").show().addClass("show"), $("#redemption-option-select .redemption-option-holder").hide(), $("#coupon-code-submit-btn").hide();
                },
                o = function (e) {
                    $("#redeemerror").show().addClass("show");
                };
            swellAPI.makeRedemption({ redemptionOptionId: e.val() }, i, o);
        }),
            $("#custom-referral-link-copy").on("click", function () {
                e("custom-referral-link-ui");
            });
    });
